import { render, staticRenderFns } from "./CardMisPedidos.vue?vue&type=template&id=64dbd720&"
import script from "./CardMisPedidos.vue?vue&type=script&lang=js&"
export * from "./CardMisPedidos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports